import { useCallback, useEffect, useMemo, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { Routes } from 'routes';
import Processing from '../Processing';
import { Popup } from 'components/Popup';
import { Success } from 'components/Success';
import { facebookEventLead } from 'components/Payment/utils';
import { globalState } from 'store/reducer';
import styles from './styles.module.scss';

import visa from 'assets/img/visa.png';
import mastercard from 'assets/img/mastercard.png';
import card from 'assets/img/Frame 5405.png';
import Footer from '../Footer';

const visaImg = visa;
const mastercardImg = mastercard;

export const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [formActive, setFormActive] = useState(1);
  const [phoneCode, setPhoneCode] = useState(null);
  const [lpPrice, setLpPrice] = useState('€2.95');
  const [loadPage, setLoadPage] = useState(false);

  const locale = useSelector(globalState.selectors.locale);
  const vocab = useSelector(globalState.selectors.vocab);
  const navigatorLocale = useSelector(globalState.selectors.navigatorLocale);
  const clickData = useSelector(globalState.selectors.clickData);
  const showPopup = useSelector(globalState.selectors.showPopup);
  const showLoader = useSelector(globalState.selectors.showLoader);
  const successPayment = useSelector(globalState.selectors.successPayment);

  const mainTexts = useMemo(
    () => vocab[navigatorLocale].mainTexts,
    [vocab, navigatorLocale]
  );

  const footerText = useMemo(
    () => vocab[navigatorLocale].footer,
    [vocab, navigatorLocale]
  );

  useEffect(() => {
    getNavigatorLocale();
    getLocale();
  }, []);

  useEffect(() => {
    if (location.pathname.includes('payment')) {
      setFormActive(2);
    } else {
      setFormActive(1);
    }
  }, [location.pathname]);

  useEffect(() => {
    redirectResult();
    checkOpportunity();
    setTitle();
    const parsed = queryString.parse(location.search);
    Object.keys(clickData).map((el) => {
      if (el in parsed) {
        dispatch(
          globalState.actions.setClickData({ key: el, value: parsed[el] })
        );
      }
    });
  }, []);

  useEffect(() => {
    checkOpportunity();
  }, [location]);

  // payment success
  useEffect(() => {
    if (window.localStorage.getItem('data_token')) {
      dispatch(globalState.actions.setSuccessPayment());
    }
  }, []);

  const getPhoneCode = useCallback(() => {
    return vocab[locale].mask.phone.split(' ').slice(0, 1).join('');
  }, [vocab, locale]);

  // get phone code
  useEffect(() => {
    const code = getPhoneCode();
    setPhoneCode(code);
  }, [getPhoneCode]);

  // load page
  useEffect(() => {
    if (!phoneCode) return;
    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    const now = (Date.now() / 1000).toFixed();
    let time = now;
    if (params.get('s') !== null) {
      localStorage.setItem('s', params.get('s'));
    }
    if (params.get('sub4') !== null) {
      let sub4 = params.get('sub4');
      if (sub4.split('+')[0] !== undefined) {
        localStorage.setItem('firstName', sub4.split('+')[0]);
      }
      if (sub4.split('+')[1] !== undefined) {
        localStorage.setItem('lastName', sub4.split('+')[1]);
      }
    }
    if (params.get('sub5') !== null) {
      let sub5 = params.get('sub5');
      if (sub5.split('+')[0] !== undefined) {
        localStorage.setItem('email', sub5.split('+')[0]);
      }
      if (sub5.split('+')[1] !== undefined) {
        localStorage.setItem('phone', phoneCode + sub5.split('+')[1]);
      }
    }
    if (params.get('sub6') !== null) {
      let sub6 = params.get('sub6');
      if (sub6 !== undefined) {
        localStorage.setItem('sub6', sub6);
      }
    }
    if (params.get('sub7') !== null) {
      let sub7 = params.get('sub7');
      if (sub7 !== undefined) {
        localStorage.setItem('sub7', sub7);
      }
    }
    if (params.get('sub8') !== null) {
      let sub8 = params.get('sub8');
      if (sub8 !== undefined) {
        localStorage.setItem('sub8', sub8);
      }
    }
    if (params.get('d') !== null) {
      time = params.get('d').split('.')[11];
      setLoadPage(now - time < 300);
    } else {
      setLoadPage(true);
    }
  }, [phoneCode]);

  const getParams = (parameterName) => {
    let result = null,
      tmp = [];

    location.search
      .substr(1)
      .split('&')
      .forEach(function (item) {
        tmp = item.split('=');
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      });

    return result;
  };

  const redirectResult = () => {
    const dataParams = getParams('data');
    if (dataParams === 'true') {
      dispatch(
        globalState.actions.showPopupHandler(
          `Your participation has been confirmed!<br/>The winner of the prize will be contacted by email.<br/>For any questions call support<br/>`
        )
      );
      dispatch(globalState.actions.setSuccessPayment());
      facebookEventLead();
    }
    if (dataParams === 'false') {
      dispatch(
        globalState.actions.showPopupHandler(
          'Error! Unfortunately an error has occurred with the payment! Check that you have entered the details correctly or try again with a different credit card.<br/><br/> Click here and try again!'
        )
      );
    }
  };

  const getLocale = () => {
    const lang = document.querySelector('html').getAttribute('lang') || 'en';
    dispatch(globalState.actions.setLocale(lang));
    dispatch(globalState.actions.getFakerLocal());
  };

  const changedTopNavLocal = (htmlLang) => {
    if ('ch' === htmlLang) setLpPrice('2.91 CHF');
    if ('au' === htmlLang) setLpPrice('3.10 $');
    if ('dk' === htmlLang) setLpPrice('21.94 DKK');
    if ('se' === htmlLang) setLpPrice('32.15 SEK');
    if ('no' === htmlLang) setLpPrice('31.04 NOK');
    if ('pl' === htmlLang) setLpPrice('13.83 zł');
    if ('nz' === htmlLang) setLpPrice('4.88 NZD');
    if ('sa' === htmlLang) setLpPrice('12 SAR');
    if ('cz' === htmlLang) setLpPrice('72,85 CZK');
  };

  const changedTopNavLocalCountry = (htmlLang) => {
    if ('fr' === htmlLang) localStorage.setItem('countryName', 'France');
    if ('au' === htmlLang) localStorage.setItem('countryName', 'Australia');
    if ('es' === htmlLang) localStorage.setItem('countryName', 'Spain');
    if ('it' === htmlLang) localStorage.setItem('countryName', 'Italy');
    if ('de' === htmlLang) localStorage.setItem('countryName', 'Germany');
    if ('pl' === htmlLang) localStorage.setItem('countryName', 'Poland');
    if ('nz' === htmlLang) localStorage.setItem('countryName', 'New Zealand');
    if ('ch' === htmlLang) localStorage.setItem('countryName', 'Switzerland');
    if ('pt' === htmlLang) localStorage.setItem('countryName', 'Portugal');
    if ('cz' === htmlLang)
      localStorage.setItem('countryName', 'Czech Republic');
  };

  const getNavigatorLocale = () => {
    const navigatorLang = navigator.language.substring(0, 2);
    const htmlLang =
      document.querySelector('html').getAttribute('lang') || 'en';
    dispatch(
      globalState.actions.setNavigatorLocale({ navigatorLang, htmlLang })
    );
    changedTopNavLocal(htmlLang);
    changedTopNavLocalCountry(htmlLang);
  };

  const setTitle = () => {
    document.querySelector('title').innerText = mainTexts.siteTitle;
  };

  const checkOpportunity = () => {
    if (window.localStorage.getItem('count') >= 2) {
      try {
        if (failedPaymentLink && failedPaymentLink !== '') {
          window.location.href = failedPaymentLink;
        }
      } catch (err) {
        setTimeout(() => {
          window.location.href = 'https://google.com';
        }, 3000);
      }
    }
  };

  // const sub6 = localStorage.getItem('sub6') ?? '';
  const sub7 = localStorage.getItem('sub7') ?? '';
  const sub8 = localStorage.getItem('sub8') ?? '';

  return (
    <Fragment>
      {showLoader && <Processing />}
      {loadPage && (
        <div className={showLoader && styles.hiddenProcessing}>
          <div
            id="main"
            className={styles.main}
          >
            <div className={styles.totalBox}>
              <div className={styles.totalBoxField}>
                {mainTexts.subtotalText}
              </div>
              <img
                src={sub8}
                alt=""
                style={{ maxWidth: '340px' }}
              />
              <div className={styles.totalBoxField}>
                <span>{sub7}</span>{' '}
                <span className={styles.violin}>{lpPrice}</span>
              </div>
              <div className={styles.totalBoxField}>
                <span>{mainTexts.subtotalText}</span>{' '}
                <span className={styles.violin}>{lpPrice}</span>
              </div>
              <div className={styles.totalBoxField}>
                <span>{mainTexts.shippingText}</span>{' '}
                <span>{mainTexts.freeText}</span>
              </div>
              <div className={styles.totalBoxField}>
                <span>{mainTexts.totalText}</span> <span>{lpPrice}</span>
              </div>
            </div>
            {/*<h1 class="text-center">{{mainTexts.siteTitle}}</h1>*/}
            <div className="top-section">
              <div className="container">
                <div className="row">
                  <div className="col-12 сol-md-6 mx-auto">
                    <div className="intro-form">
                      <div className="text-center">
                        <hr
                          className="invisible m-0"
                          id="scroll"
                        />
                        <div className="">
                          {successPayment ? <Success /> : <Routes />}
                        </div>
                        <br />
                        <Footer
                          mainTexts={mainTexts}
                          footerText={footerText}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <br />
          </div>
          {showPopup && <Popup />}
        </div>
      )}
    </Fragment>
  );
};
